import { Link } from 'react-router-dom';
import ContactForm from './ContactForm';
import useScrollToTop from './useScrollToTop';

function Home() {
  useScrollToTop();
  return (
    <div className="home-body">
    <div className="hero">
        <div className="hero-content">
          <h1>KMS Sound Strategies</h1>
          <p>Audio Solutions and Digital Products</p>
          <Link to="/contact"><button>Request a Quote!</button></Link> 
        </div>
    </div>
    <div className="cards-offset-background">

    <div className="services-cards">
        <Link to="/services#audio-mixing" className="services-card">
                <h2>Audio Mixing</h2>
                <p>Our mixing services are designed to enhance every detail of your music, helping you achieve a professional results at a price you can afford. Our engineers are flexible with revisions and dedicated to getting your music sounding it's best</p>
        </Link>
        <Link to="/services#audio-mastering" className="services-card">
                <h2>Audio Mastering</h2>
                <p>Our mastering services will get your audio bradcast-ready for a variety of formats including digital delivery and streaming.</p>
        </Link>
        <Link to="/services#audio-restoration" className="services-card">
            <h2>Audio Restoration</h2>
            <p>Our audio restoration services can help solve tricky audio problems and get any recording created in less-than-ideal situations back on track for broadcast or as a work sample.</p>
        </Link >
    </div>
    </div>
    
    <div className="home-text-container">
      <div className='home-text-flex-container'>
        <div className="home-text">
              <p>
              Elevate Your Sound with Professional Remote Mixing & Mastering
          At KM Sound Strategies, we bring studio-quality sound to artists around the world. Our expert mixing and mastering services are designed to enhance every detail of your music, helping you achieve a polished, release-ready track from the comfort of your home. Whether you're an independent musician, producer, or band, we tailor our approach to match your unique style and vision.
          Using state-of-the-art tools and years of experience, we refine your tracks with precision—balancing instruments, enhancing vocals, and adding that final professional touch. Our remote process is seamless: simply send us your files, and we'll handle the rest making sure you approve all changes and revisions along the way. 
          Take your sound to the next level, your art deserves nothing less than perfection.

          Let’s create something extraordinary.
              </p>
          </div>
      </div>
    </div>
    <div>
      <h2>Contact</h2>
      <ContactForm />
    </div>
    
    </div>
  );
};

export default Home;